import { useRecoilValue } from "recoil";
import { ActionsCell } from "../../../../Component/Common/Components/DataTable/ActionsCell";
import { DefaultCell } from "../../../../Component/Common/Components/DataTable/DefaultCell";
import { EE123PeopleRole_Edit, PeopleEditRole } from "../../../../Component/Common/Constants/UserRoles";
import { Individual } from "../../../../Component/Model/Dto/Individual";
import { ActionType, TableColumn } from "../../../../Component/Model/Table/Table";
import { userRolesState } from "../../../../State/user.Atom";

interface IEmploymentDataRows {
    OccupationalLevelName: string;
    Position: string;
    EmployeeTypeName: string;
    OfoCode: string | null;
    IsPermanent: string;
    StartDateDateTime: string | undefined;
    EndDateDateTime: string | undefined;
    Actions: ActionType[];
}


export interface IEmploymentTable {
    columns: Array<TableColumn>;
    rows: Array<IEmploymentDataRows>;
}

export function EmploymentDataTableMapper(results: Individual.EmploymentDataRowDto[], onEditEmploymentRow: (id: number) => void, onDeleteEmploymentRow: (id: number) => void): IEmploymentTable {
    const columns = [
        { Header: 'Level', accessor: 'OccupationalLevelName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Position', accessor: 'Position', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Employee Status', accessor: 'EmployeeTypeName', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'OFO Code', accessor: 'OfoCode', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Permanent', accessor: 'IsPermanent', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Start Date', accessor: 'StartDateDateTime', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'End Date', accessor: 'EndDateDateTime', Cell: ({ value }: any) => <DefaultCell value={value} /> },
        { Header: 'Actions', accessor: 'Actions', Cell: ({ value }: any) => <ActionsCell actions={value} />, disableSortBy: true },
    ];

    const editRoleAccess = [
        EE123PeopleRole_Edit
    ]
    const userRoles = useRecoilValue(userRolesState);
    const isEditable = userRoles.some(r => editRoleAccess.includes(r));


    if (results.length >= 0) {

        const rows = results.map((item: Individual.EmploymentDataRowDto, index: number) => (
            {
                ...item,
                IsPermanent: item.IsPermanent === true ? "Yes" : " No",
                Actions: results.length >= 2 ? [
                    isEditable ?
                        {
                            key: index.toString(),
                            label: 'View/Edit',
                            action: () => {
                                onEditEmploymentRow(item.IndividualEmployeeDataId);
                            },
                            icon: {
                                color: 'info',
                                name: 'edit'
                            }
                        } : {
                            key: index.toString(),
                            label: 'View',
                            action: () => {
                                onEditEmploymentRow(item.IndividualEmployeeDataId);
                            },
                            icon: {
                                color: 'info',
                                name: 'visibility'
                            }
                        }
                    ,
                    ...(isEditable ? 
                            [{
                                key: index.toString(),
                                label: 'Delete',
                                action: () => {
                                    onDeleteEmploymentRow(item.IndividualEmployeeDataId);
                                },
                                icon: {
                                    color: 'error',
                                    name: 'delete'
                                }
                            }] 
                            : []
                        )
                ] : [
                    isEditable ?
                        {
                            key: index.toString(),
                            label: 'View/Edit',
                            action: () => {
                                onEditEmploymentRow(item.IndividualEmployeeDataId);
                            },
                            icon: {
                                color: 'info',
                                name: 'edit'
                            }
                        } : {
                            key: index.toString(),
                            label: 'View',
                            action: () => {
                                onEditEmploymentRow(item.IndividualEmployeeDataId);
                            },
                            icon: {
                                color: 'info',
                                name: 'visibility'
                            }
                        }
                ]
            }));

        return { columns: columns, rows: rows };
    }
    else {
        return { columns: columns, rows: [] };
    }
}